<header class="section-title general-structure-full-width">
  <div class="general-structure">
    <div>
      <h2>{{title}}</h2>
      <div class="subtype">
        <mat-icon *ngIf="svgIcon" svgIcon="{{svgIcon}}" class="section-icon"></mat-icon>
        <mat-icon *ngIf="icon" class="section-icon">{{icon}}</mat-icon>
        <span>Observatorios</span>
      </div>
    </div>
    <button mat-icon-button (click)="onClick()" class="menu-button">
      <mat-icon class="icon-menu">menu</mat-icon>
    </button>
  </div>
</header>